import { ReactionType } from "./user";

export enum ClassEventTypeType {
  BOOKMARK_NOTE = "bookmark-note",
  CLASSROOM_VISIBILITY = "classroom-visibility",
  EMOTION = "emotion",
  MESSAGE = "message",
  QUICK_POLL_RESPONSE = "quick-poll-response",
  TIMELINE_SEGMENT = "timeline-segment",
  TIMELINE_SEGMENT_SECONDARY_ACTION = "timeline-segment-secondary-action",
  VOICE = "voice",
}

interface BookmarkNoteEventType {
  type: ClassEventTypeType.BOOKMARK_NOTE;
  data: {
    note_text: string;
    additional_offset: number;
  };
}

interface ClassroomVisibilityType {
  type: ClassEventTypeType.CLASSROOM_VISIBILITY;
  data: {
    isVisible: boolean;
  };
}

interface EmotionEventType {
  type: ClassEventTypeType.EMOTION;
  data: {
    emotion: "hand-raise" | Exclude<ReactionType, null>;
  };
}

interface MessageEventType {
  type: ClassEventTypeType.MESSAGE;
  data: {
    message_text: string;
  };
}

type TimelineSegmentEventType =
  | {
      type: ClassEventTypeType.TIMELINE_SEGMENT;
      data: {
        "timeline-segment-id": string;
        "timeline-segment-title": string;
      };
    }
  | {
      type: ClassEventTypeType.TIMELINE_SEGMENT_SECONDARY_ACTION;
      data: {
        op: string;
        "timeline-segment-id": string;
      };
    };

interface VoiceEventType {
  type: ClassEventTypeType.VOICE;
  data: {
    duration: number;
  };
}

interface VoteEventType {
  type: ClassEventTypeType.QUICK_POLL_RESPONSE;
  data: {
    response: "yes" | "no";
  };
}

export type ClassEventTypeAndDataType =
  | BookmarkNoteEventType
  | ClassroomVisibilityType
  | EmotionEventType
  | MessageEventType
  | TimelineSegmentEventType
  | VoiceEventType
  | VoteEventType;

export type ClassEventType = ClassEventTypeAndDataType & {
  // Note that "type" is called "event_type" in Picasso, "data" is called "event_data"
  // and "userId" is called "actor_id", but this otherwise matches the Picasso model schema.
  id: string;
  roomId: string;
  userId: string;
  timestamp: number;
};
